/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addDataMigration } from '../fn/data-migrations/add-data-migration';
import { AddDataMigration$Params } from '../fn/data-migrations/add-data-migration';
import { deleteDataMigration } from '../fn/data-migrations/delete-data-migration';
import { DeleteDataMigration$Params } from '../fn/data-migrations/delete-data-migration';
import { SuccessfulResponse as DigiworkMaitreDApiConfigurationModelSuccessfulResponse } from '../models/Digiwork/MaitreD/Api/Configuration/Model/successful-response';

@Injectable({ providedIn: 'root' })
export class DataMigrationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `addDataMigration()` */
  static readonly AddDataMigrationPath = '/api/data-migrations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addDataMigration()` instead.
   *
   * This method doesn't expect any request body.
   */
  addDataMigration$Response(params?: AddDataMigration$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
    return addDataMigration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addDataMigration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addDataMigration(params?: AddDataMigration$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelSuccessfulResponse> {
    return this.addDataMigration$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>): DigiworkMaitreDApiConfigurationModelSuccessfulResponse => r.body)
    );
  }

  /** Path part for operation `deleteDataMigration()` */
  static readonly DeleteDataMigrationPath = '/api/data-migrations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDataMigration()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDataMigration$Response(params?: DeleteDataMigration$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
    return deleteDataMigration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDataMigration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDataMigration(params?: DeleteDataMigration$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelSuccessfulResponse> {
    return this.deleteDataMigration$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>): DigiworkMaitreDApiConfigurationModelSuccessfulResponse => r.body)
    );
  }

}
